import { NgModule } from '@angular/core'
import { CancelDispenserAgreementModalModule } from './cancel-dispenser-agreement-modal/cancel-dispenser-agreement-modal.module'
import { CancelDispenserAgreementModule } from './cancel-dispenser-agreement/cancel-dispenser-agreement.module'
import { DispenserAgreementDetailModule } from './dispenser-agreement-detail/dispenser-agreement-detail.module'
import { DispenserAgreementHistoryModule } from './dispenser-agreement-history/dispenser-agreement-history.module'
import { DispenserAgreementPlaceOrderModule } from './dispenser-agreement-place-order/dispenser-agreement-place-order.module'
import { DispenserCreditRequestModule } from './dispenser-credit-request/dispenser-credit-request.module'
import { DispenserEndCustomerModule } from './dispenser-end-customer/dispenser-end-customer.module'
import { DispenserShipmentModule } from './dispenser-shipment/dispenser-shipment.module'
import { NewDispenserAgreementModalModule } from './new-dispenser-agreement-modal/new-dispenser-agreement-modal.module'
import { NewDispenserAgreementModule } from './new-dispenser-agreement/new-dispenser-agreement.module'
import { UpdateDispenserAgreementInfoModalModule } from './update-dispenser-agreement-info-modal/update-dispenser-agreement-info-modal.module'
import { UpdateDispenserAgreementModule } from './update-dispenser-agreement/update-dispenser-agreement.module'

@NgModule({
  imports: [
    DispenserAgreementHistoryModule,
    DispenserAgreementDetailModule,
    NewDispenserAgreementModule,
    NewDispenserAgreementModalModule,
    DispenserAgreementPlaceOrderModule,
    DispenserShipmentModule,
    DispenserCreditRequestModule,
    DispenserEndCustomerModule,
    UpdateDispenserAgreementModule,
    UpdateDispenserAgreementInfoModalModule,
    CancelDispenserAgreementModule,
    CancelDispenserAgreementModalModule
  ]
})
export class DispenserAgreementModule {}
